/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum LookupType {
    Barcode = 1,
    Account = 2,
    Address = 3,
    Phone = 4,
    BarcodeWithLastName = 5,
}
